import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import CardMobileSection from 'components/sales/tableSection/cardMobileSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { STATUS } from 'constants/statusConstant';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import './siteListing.css';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const SiteListsForEngineer = ({
  getSiteListingForEngg,
  siteListData,
  getSiteFilters,
  siteFiltersForEngg,
  getLocationChange,
  locationChange,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [cardListData, setCardListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const headers = [
    'Site Number',
    'Infra Id',
    'Site Type',
    'Client Name',
    'No.of Gates',
    'Area Name',
    'Assigned To',
    'BA Name',
    'Assigned To Maintenance',
    'Onboard Date',
    'Inst. Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
      'Validate Location',
    'Status',
    'Actions',
  ];
  const cardHeaders = [
    'Site Number',
    'Infra Id',
    'Site Type',
    'Client Name',
    'Area Name',
    'BA Name',
    'Onboard Date',
    'Inst. Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
    'Validate Location',
    'Status',
    'Actions',
  ];
  console.log('PAGE::SITE_LIST_FOR_ENGINEER');
    async function fetchAttData() {
        try {
          // fetchAttd
            const url = `${Config.attendance.fetchAttd}`;

            const { data } = await axios.get(url);
            //console.log(data.response.data)
            // setData(data?.response?.data);
        } catch {
            console.log('Something went wrong');
        }
    }

  useEffect(() => {
    fetchAttData();
    const installationCont = JSON.parse(
      localStorage.getItem("installationCont") &&
        localStorage.getItem("installationCont")
    );
    if(installationCont){
      localStorage.setItem("installationContractList", JSON.stringify(""));
      localStorage.setItem("installationCont", 0);
    }
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setIsRoleId(roles[0].pivot.role_id);
      })();
    }, 0);
  }, []);

  useEffect(() => {
    if (getSiteListingForEngg !== null)
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("installationContractList") &&
            localStorage.getItem("installationContractList")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await getSiteListingForEngg(getcontractFilter);
        }else{
          await getSiteListingForEngg();
        }

      })();
  }, [getSiteListingForEngg]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {

    const tableData = [
      'site_id',
      'site_no',
      'infra_project_id',
      'lead_id',
      'site_type',
      'client_name',
      'gates',
      'area_name',
      'assigned_to',
      'ba_name',
      'assigned_to_maintenance',
      'created_at',
      'installation_start_date',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
      'status',
    ];
    const cardTableData = [
      'site_id',
      'site_no',
      'infra_project_id',
      'lead_id',
      'site_type',
      'client_name',
      'area_name',
      'ba_name',
      'created_at',
      'installation_start_date',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
      'status',
    ];
    //console.log(siteListData);
    if (siteListData && siteListData.resultSets) {
      const cardData = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...cardTableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
            [
              { name: 'View Task Details', link: '/dashboard/view-tasks-info' }
            ]
          }
        )
      );
      if (cardData) {
        const newCardData = cardData.map(function (obj) {
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newCardData && setCardListData(newCardData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }

    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
            [
              { name: 'View Task Details', link: '/dashboard/view-tasks-info' }
            ]
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData, isRoleId]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const redirectToBulkAssignment = () => {
    history.push(`${baseUrl}/bulk-assignment?type=installationContractList`);
  }

  const applyFilter = async (filterData) => {
    localStorage.setItem("installationContractList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteListingForEngg(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
        <>
      <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
      >
        <img src={Images?.Filter} alt="" />
        <b className="site_filters" style={{width:"max-content"}}>
        {localization.showFilters}
        </b>
      </Button>
        </>
    );
  };

  const onPageChange = async (val) => {
  
    let filter = JSON.parse(localStorage.getItem("installationContractList") && localStorage.getItem("installationContractList"));
    setIsLoading(true);
    await getSiteListingForEngg(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const updateLocation = (val) => {
    const isLocation = val.check === false ? 0 : 1;
    getLocationChange(val.id, isLocation);
  };

  useEffect(() => {
    (async () => {
      if (locationChange.status) {
        setIsLoading(true);
        await getSiteListingForEngg();
        setIsLoading(false);
      }
    })();
  }, [locationChange]);

  return (
    <Layout
      title={localization.siteList}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      {window.screen.width < 1000?
      <CardMobileSection
        data={cardListData}
        isId={false}
        isMngId={false}
        headers={cardHeaders}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
      />
      :
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
      />
      }
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFiltersForEngg?.site_types ? siteFiltersForEngg : null}
        siteFiltersForEngg
      />
    </Layout>
  );
};

export default SiteListsForEngineer;
